import { createTheme } from "@mui/material";

const theme = createTheme({
  spacing: 8, // Adjust the spacing value as needed
  // Add other theme configurations here
});

export default theme;
